angular.module('tgaAdmin')
  .controller('LoginCommonController', [
    '$scope', '$state', '$cookies', '$window', '$location', 'userService', 'settingsService', 'domainService',
    function (
      $scope, $state, $cookies, $window, $location, userService, settingsService, domainService,
    ) {
      $scope.checkingCookie = true;

      const redirectKey = 'tgaRedirect';

      if (userService.isLoggedIn()) {
        $state.go('v1.games');
        return;
      }
      $scope.checkingCookie = false;

      $scope.data = {
        alerts: [],
        logo: '',
        defaultLogo: './v1/assets/images/logo-black.svg',
      };

      $scope.viewmodel = {
        username: '',
        password: '',
        remember: false,
        access_token: $location.search().accessToken,
        rt: $location.search().rt,
      };

      $scope.initialize = function () {
        settingsService.getSettings().then((settings) => {
          $scope.data.logo = settings.logo || $scope.data.defaultLogo;
        });

        if ($scope.viewmodel.access_token) {
          $scope.checkingSSO = true;
          userService.loginCommon($scope.viewmodel).then((response) => {
            $scope.actions.redirect(response, response.domain);
          }, (err) => {
            $scope.checkingSSO = false;
            $scope.actions.createAlert(err.message, 'danger');
          });
        }
      };

      $scope.actions = {
        redirect(user, domain) {
          const expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 1);

          $cookies.putObject(redirectKey, user, {
            path: '/',
            domain: `.${domainService.base}`,
            expires: expireDate,
          });

          let url = `${$window.location.protocol}//${domain}.${domainService.base}/admin/v1`;

          if ($location.search().route === 'arcades') {
            url += '/hubs';
          } else {
            url += '/login';
          }

          $window.location.href = url;
        },
        submit() {
          $scope.data.alerts = [];

          if ($scope.loginForm.$invalid) {
            return;
          }

          $scope.loading = true;

          userService.loginCommon($scope.viewmodel).then((response) => {
            $scope.actions.redirect(response, response.domain);
          }, () => {
            $scope.loading = false;
            $scope.actions.createAlert('Invalid username or password.', 'danger');
          });
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
